import React from 'react';
import PropTypes from 'prop-types';

const SadFace = ({ width, height, fill }) => (
  <div className="icon-sad-face">
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 127 127">
      {/* eslint-disable */}
      <path
        fill={fill}
        fillRule="nonzero"
        d="M63.24 10c-9.657 0-18.582 2.423-26.875 7.296-8.033 4.7-14.37 11.036-19.074 19.077C12.423 44.658 10 53.583 10 63.24s2.423 18.582 7.316 26.91c4.605 8.016 10.887 14.34 18.917 19.04 8.283 4.866 17.255 7.29 27.007 7.29 9.752 0 18.724-2.424 27.05-7.316 8.005-4.599 14.275-10.869 18.9-18.917 4.866-8.283 7.29-17.255 7.29-27.007 0-9.752-2.424-18.724-7.316-27.05-4.599-8.005-10.869-14.275-18.917-18.9C81.964 12.425 72.992 10 63.24 10zm0-10c11.528 0 22.25 2.896 32.03 8.644 9.541 5.481 17.085 13.025 22.54 22.523 5.774 9.824 8.67 20.545 8.67 32.073 0 11.528-2.896 22.25-8.644 32.03-5.481 9.541-13.025 17.085-22.523 22.54-9.824 5.774-20.545 8.67-32.073 8.67-11.528 0-22.25-2.896-32.065-8.664-9.525-5.573-17.056-13.155-22.506-22.643C2.897 85.351 0 74.676 0 63.24s2.897-22.111 8.664-31.925C14.231 21.8 21.801 14.23 31.307 8.669 41.129 2.897 51.804 0 63.24 0zM31 86a5 5 0 1 1 0-10h64.41a5 5 0 0 1 0 10H31zm52.82-28.5c-2.52 0-4.62-.84-6.3-2.52C75.84 53.3 75 51.2 75 48.68s.84-4.597 2.52-6.23C79.2 40.817 81.3 40 83.82 40s4.597.84 6.23 2.52c1.633 1.68 2.45 3.733 2.45 6.16s-.84 4.503-2.52 6.23c-1.68 1.727-3.733 2.59-6.16 2.59zm-41.02 0c-2.52 0-4.62-.84-6.3-2.52-1.68-1.68-2.52-3.78-2.52-6.3s.84-4.597 2.52-6.23c1.68-1.633 3.78-2.45 6.3-2.45s4.597.84 6.23 2.52c1.633 1.68 2.45 3.733 2.45 6.16s-.84 4.503-2.52 6.23c-1.68 1.727-3.733 2.59-6.16 2.59z" />
      {/* eslint-enable */}
    </svg>
  </div>
);

SadFace.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

SadFace.defaultProps = {
  fill: '#CCCCCC',
  width: '125',
  height: '125',
};

export default SadFace;
